import { create } from 'zustand'

interface Toast {
  id:      string
  type:    'success' | 'error' | 'info' | 'warning'
  title:   string
  message?: string
}

interface UIState {
  sidebarOpen: boolean
  toasts:      Toast[]

  toggleSidebar: () => void
  setSidebar:    (open: boolean) => void
  addToast:      (toast: Omit<Toast, 'id'>) => void
  removeToast:   (id: string) => void
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  toasts:      [],

  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebar:    (open) => set({ sidebarOpen: open }),

  addToast: (toast) =>
    set((s) => ({
      toasts: [
        ...s.toasts,
        { ...toast, id: crypto.randomUUID() },
      ],
    })),

  removeToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))
